import { render, staticRenderFns } from "./PaymentsInfoPage.vue?vue&type=template&id=2b0ae0d1&scoped=true&"
import script from "./PaymentsInfoPage.vue?vue&type=script&lang=js&"
export * from "./PaymentsInfoPage.vue?vue&type=script&lang=js&"
import style0 from "./PaymentsInfoPage.vue?vue&type=style&index=0&id=2b0ae0d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0ae0d1",
  null
  
)

export default component.exports